module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYBAMAAAA46dFkAAAALVBMVEVHcEz////////////////////////////////////////////////////////NXt0CAAAADnRSTlMAIOnbW0YQ1w3yQxPDwHxvxNIAAABaSURBVAjXY9hzjQEM7J43gOl37yzAtN+7xxtANMu7d2UwgQaogBlU4HkCVACuBSZQDRZY+e45mJZ89xhEsb57pwii1717JIDEjcPLhSpmgHIZ5kG4DMKFYAoAzHoytBkOPKEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/arrow.png
// module id = OqrI
// module chunks = 3